<template>
  <div class="deposit-funds-vue">
    <Header class="responsive-bar">
      <template v-slot:title>
        {{ $t("deposit-funds-e645a4c2bcea65c6fccd26238e52ec6e") }}
      </template>
    </Header>
    <AlertNav
      :alert-message="
        $store.getters.get_alert_nav_message ||
        'Please verify your account to enable deposits.'
      "
      v-if="$store.getters.get_alert_nav || checkTradingDays"
    />
    <div
      class="bg-white shadow rounded-md min-h-screen max-w-3xl m-auto sm:mt-5"
    >
      <div v-if="response.hasData">
        <div>
          <!--       Iframe for deposit funds-->
          <div v-if="response.opening_type === 'iframe'" class="p-6">
            <iframe :src="response.url" frameborder="0"></iframe>
          </div>

          <!--        Modal for deposit funds-->
          <div
            v-if="response.opening_type === 'modal' && showModal"
            class="p-6"
          >
            <div class="fixed z-10 inset-0 overflow-y-auto">
              <div
                class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
              >
                <div class="fixed inset-0 transition-opacity">
                  <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                  class="hidden sm:inline-block sm:align-middle sm:h-screen"
                ></span
                >&#8203;

                <div
                  aria-labelledby="modal-headline"
                  aria-modal="true"
                  class="min-h-screen relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6"
                  role="dialog"
                >
                  <div
                    class="absolute top-2 right-2"
                    @click="showModal = false"
                  >
                    <button
                      aria-label="Close panel"
                      class="text-gray-400 hover:text-gray-500 transition ease-in-out duration-150"
                    >
                      <!-- Heroicon name: x -->
                      <svg
                        class="h-6 w-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 18L18 6M6 6l12 12"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                      </svg>
                    </button>
                  </div>
                  <div>
                    <div class="mt-3 text-center sm:mt-5">
                      <iframe
                        :src="response.url"
                        frameborder="0"
                        style="width: 100%; height: 50rem"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="'state' in get_profile">
        <div
          v-if="get_profile.state === 'Limited' && whitelabel !== 'VCGMarkets'"
          class="rounded-md bg-yellow-50 sm:p-5 m-8"
        >
          <p>
            Your account is in limited state<span
              v-if="get_profile.profile.limits.deposits !== 0"
              >,</span
            >
          </p>
          <p v-if="get_profile.profile.limits.deposits !== 0">
            the Deposits are limited to
            {{ get_profile.profile.limits.deposits }}
            {{ get_profile.profile.reporting_currency }} total
          </p>
        </div>
        <!--        <div-->
        <!--          v-if="get_profile.state === 'Limited' && whitelabel === 'VCGMarkets'"-->
        <!--          class="rounded-md bg-yellow-50 sm:p-5 m-8"-->
        <!--        >-->
        <!--          <p v-if="get_profile.profile.limits.deposits !== 0">-->
        <!--            Please upload your documents in order to Deposit-->
        <!--          </p>-->
        <!--        </div>-->
      </div>

       

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(makeDeposit)">
          <div>
            <div class="flex justify-between">
              <h3 class="py-5 text-lg leading-6 font-medium text-gray-900">
                {{ $t("deposit-funds-e645a4c2bcea65c6fccd26238e52ec6e") }}
              </h3>
            </div>
          </div>

          
          <!--#BR#23 - Mbeng Atemson 23/10/2024 -KYC verification message  and whitelabel !== 'ICMMU' -->
          <!--#BR#73 - Mbeng Atemson 09/04/2025 -KYC verification message  and whitelabel !== 'ICMVC' -->
          <!--#BR#52 - Mbeng Atemson  -KYC verification message  and whitelabel !== 'ICMSC' 07/08/2025 -->
          <complete-id-identification
            v-if="
              $store.getters.get_profile.state !== 'Full' &&
              $store.getters.get_profile.state !== 'Limited' &&
              (whitelabel === 'ICMMU' ||
              whitelabel === 'ICMSC' ||
              whitelabel === 'ICMVC')
             
            "
            title="KYC verification is pending, please contact Support Team."
          >
          </complete-id-identification>
          <complete-id-identification
            v-if="
              $store.getters.get_profile.state !== 'Full' &&
              $store.getters.get_profile.state !== 'Limited' &&
              whitelabel !== 'ICMMU' &&
              whitelabel !== 'ICMSC' &&
              whitelabel !== 'ICMVC'
            "
            title="before-you-are-able-to-deposit-funds-you-must-complete-id-verification-process"
          >
          </complete-id-identification>
           <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details-->
           <!-- <complet-id-identification
             v-if="whitelabel==='ICMMU' && profileLoaded && showTaxAlert">
             <TaxDetailsAlert />
          </complet-id-identification> -->
          <div
            v-if="
              account_data.length !== 0 &&
              ($store.getters.get_profile.state === 'Full' ||
                $store.getters.get_profile.state === 'Limited')
            "
            class="border-t border-gray-200"
          >
            <div class="flex flex-col">
              <div>
                <div class="align-middle inline-block min-w-full">
                  <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                    <dt class="text-sm mb-4 leading-5 font-normal">
                      {{
                        $t(
                          "please-select-the-account-you-wish-to-deposit-funds-to"
                        )
                      }}
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0">
                      <div class="grid sm:grid-cols-3 grid-cols-2 gap-4">
                        <button
                          v-for="(account, index) in account_data"
                          :key="index"
                          :class="
                            selectedAccount === account ? 'border-blue-500' : ''
                          "
                          class="relative text-left transition cursor-pointer duration-150 ease-in-out p-3 pr-8 border rounded mr-3 w-full focus:outline-none"
                          type="reset"
                          @click="
                            setAccount(account);
                            updatePaymentMethods();
                          "
                        >
                          <svg
                            v-if="account.backend.type === 'MT4'"
                            class="absolute top-2 right-2"
                            fill="none"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <rect fill="white" height="24" width="24" />
                            <rect
                              fill="url(#pattern0)"
                              height="16"
                              width="16"
                              x="4"
                              y="4"
                            />
                            <defs>
                              <pattern
                                id="pattern0"
                                height="1"
                                patternContentUnits="objectBoundingBox"
                                width="1"
                              >
                                <use
                                  transform="translate(-0.020202) scale(0.00505051)"
                                  xlink:href="#image0"
                                />
                              </pattern>
                              <image
                                id="image0"
                                height="198"
                                width="206"
                                xlink:href="data:image/png;base64,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"
                              />
                            </defs>
                          </svg>

                          <img
                            v-if="
                              account.backend.type === 'DXTrade' &&
                              whitelabel === 'EagleGlobalMarkets'
                            "
                            :src="
                              require('../../../assets/eagletrade-small.png')
                            "
                            alt="trading icon"
                            class="absolute top-2 right-2"
                            height="24"
                            width="24"
                          />

                          <span
                            v-if="
                              (whitelabel === 'ICMEU' ||
                                whitelabel === 'ICMVC' ||
                                whitelabel === 'ICMSC' ||
                                whitelabel === 'ICMCapital' ||
                                whitelabel === 'ICMMENA' ||
                                whitelabel === 'GCCBrokers' ||
                                whitelabel === 'ICMAP' ||
                                whitelabel === 'ICMMU' ||
                                whitelabel === 'ICMEU' ||
                                whitelabel === 'ICMTrader' ||
                                whitelabel === 'TradiNext') &&
                              account.backend.name.endsWith('IB')
                            "
                          >
                            Wallet - {{ account.external_id }}
                          </span>
                          <span
                            v-else-if="
                              (whitelabel === 'TD365' ||
                                whitelabel === 'TDSouthAfrica' ||
                                whitelabel === 'Blackstone' ||
                                whitelabel === 'EagleGlobalMarkets' ||
                                whitelabel === 'TradeCoreUK') &&
                              account.meta.Alphacode
                            "
                            class="word-break"
                          >
                            {{ checkBackendType(account.backend.type) }} -
                            {{ account.meta.Alphacode }}
                          </span>
                          <span
                            v-else-if="whitelabel === 'OrbitInvest'"
                            class="word-break"
                          >
                            {{ account.backend.display_name }}
                          </span>
                          <span
                            v-else-if="account.external_id"
                            class="word-break"
                          >
                            {{ checkBackendType(account.backend.type) }} -
                            {{ account.external_id }}
                          </span>
                          <span v-else class="word-break">
                            {{ checkBackendType(account.backend.type) }} -
                            Account not ready yet
                          </span>
                          <br />
                          <span
                            class="my-3 text-xs leading-5 font-light text-gray-400"
                          >
                            <span
                              v-if="
                                account.balance.WithdrawableAmount !== 'n/a'
                              "
                            >
                              {{
                                new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: account.currency,
                                }).format(account.balance.WithdrawableAmount)
                              }}
                            </span>
                            <span v-else>
                              {{
                                new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: account.currency,
                                }).format(0)
                              }}
                            </span>
                          </span>
                        </button>
                      </div>
                    </dd>
                  </div>
                  <div
                    v-if="
                      whitelabel !== 'ICMEU' &&
                      whitelabel !== 'TD365' &&
                      whitelabel !== 'TDSouthAfrica' &&
                      whitelabel !== 'Blackstone' &&
                      whitelabel !== 'OneTradingMarkets' &&
                      whitelabel !== 'EagleGlobalMarkets' &&
                      whitelabel !== 'TradeCoreUK'
                    "
                    class="sm:border-b border-gray-200"
                  >
                    <div
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-10 sm:gap-4 sm:border-gray-200 sm:border-t sm:py-5"
                    >
                      <dt class="text-sm leading-5 font-normal sm:col-span-4">
                        {{ $t("choose-payment-method-for-selected-account") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-5"
                      >
                        <div class="sm:col-span-2">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="currency"
                            rules="required"
                          >
                            <v-select
                              v-model="selectedPayment"
                              :clearable="false"
                              :dir="
                                checkLanguageDirection === 'rtl'
                                  ? 'rtl'
                                  : 'auto'
                              "
                              :disabled="
                                $store.getters.get_live_accounts.length === 0
                              "
                              :options="get_deposit_methods"
                              :placeholder="
                                $t(
                                  'select-an-option-59d5d61e9e9b2dc33a0211623cc4fe11'
                                )
                              "
                              label="name"
                              @input="updateSelectedGateway"
                            ></v-select>
                            <span class="text-sm text-red-600 h-4">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </dd>
                    </div>
                  </div>
                  <div
                    v-if="
                      selectedPayment &&
                      whitelabel !== 'OneTradingMarkets' &&
                      whitelabel !== 'EagleGlobalMarkets' &&
                      whitelabel !== 'ICMEU' &&
                      whitelabel !== 'TD365' &&
                      whitelabel !== 'TDSouthAfrica' &&
                      whitelabel !== 'TradeCoreUK'
                    "
                  >
                    <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                      <dt class="text-sm leading-5 font-normal mb-3">
                        {{ $t("choose-a-payment-gateway-for-selected-method") }}
                      </dt>
                      <dd
                        v-if="get_payments_gateway.payment_gateways"
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                      >
                        <div class="grid grid-cols-3 gap-6">
                          <div
                            v-for="(
                              gateway, index
                            ) in get_payments_gateway.payment_gateways.filter(
                              (item) =>
                                selectedPayment.gateways.includes(item.name)
                            )"
                            :key="index"
                            :class="
                              selectedGateway.name === gateway.name
                                ? 'border-blue'
                                : ''
                            "
                            class="flex flex-col border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                            @click="setGateway(gateway)"
                          >
                            <!-- <img :src="require(`../../../assets/gateways/${gateway.name}${(gateway.name === 'praxispay' || gateway.name === 'bridgerpay' || gateway.name === 'vaultspay') ? '.png' : '.svg'}`)" class="m-auto rounded-md" :class="(gatewayLabels[gateway.name] || gateway.name === 'praxispay' || gateway.name === 'bridgerpay' || gateway.name === 'vaultspay') ? 'h-16':'h-24'" alt=""> -->
                            <img
                              :src="checkAsset(gateway.name)"
                              alt=""
                              class="m-auto"
                              style="
                                height: 100%;
                                width: auto;
                                max-height: 48px;
                              "
                            />
                            <div
                              v-if="
                                gateway.name !== 'qubepay' &&
                                gateway.name !== 'worldpay'
                              "
                              class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                            >
                              <span
                                v-if="
                                  gateway.name === 'bridgerpay' ||
                                  gateway.name === 'praxispay'
                                "
                              >
                                Payment Solutions
                              </span>
                              <template v-else>
                                <span class="mr-2">
                                  {{ $t("via") }}
                                </span>
                                <span v-if="gatewayLabels[gateway.name]">
                                  {{ gatewayLabels[gateway.name] }}
                                </span>
                                <span v-else>
                                  {{ gateway.name }}
                                </span>
                              </template>
                            </div>
                            <div
                              v-else
                              class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                            >
                              <span
                                v-if="gateway.name !== 'qubepay'"
                                class="mr-2"
                              >
                                {{ $t("via") }}
                              </span>
                              <span> Card Payments </span>
                            </div>
                          </div>
                        </div>
                      </dd>
                    </div>
                  </div>

                  <!-- if deposit_methods array is empty (this happends in ICMEU) -->
                  <div
                    v-if="
                      get_deposit_methods.length === 0 && whitelabel === 'ICMEU'
                    "
                  >
                    <div>
                      <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                        <dt class="text-sm leading-5 font-normal mb-3">
                          {{
                            $t("choose-a-payment-gateway-for-selected-method")
                          }}
                        </dt>
                        <dd
                          v-if="get_payments_gateway.payment_gateways"
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                        >
                          <div class="grid grid-cols-3 gap-6">
                            <div
                              :class="
                                selectedGateway.name ===
                                get_payments_gateway.payment_gateways[0].name
                                  ? 'border-blue'
                                  : ''
                              "
                              class="flex flex-col border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                            >
                              <!-- we select this gateway by default since there is only one gateway -->
                              {{
                                setGateway(
                                  get_payments_gateway.payment_gateways[0]
                                )
                              }}
                              <img
                                :src="
                                  require(`../../../assets/gateways/${get_payments_gateway.payment_gateways[0].name}.svg`)
                                "
                                alt=""
                                class="m-auto"
                                style="
                                  height: 100%;
                                  width: auto;
                                  max-height: 48px;
                                "
                              />
                              <div
                                v-if="
                                  gatewayLabels[
                                    get_payments_gateway.payment_gateways[0]
                                      .name
                                  ]
                                "
                                class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                              >
                                <span class="mr-2">
                                  {{ $t("via") }}
                                </span>
                                <span>
                                  {{
                                    gatewayLabels[
                                      get_payments_gateway.payment_gateways[0]
                                        .name
                                    ]
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </dd>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      whitelabel === 'TD365' || whitelabel === 'TDSouthAfrica'
                    "
                  >
                    <div>
                      <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                        <dd
                          v-if="get_payments_gateway.payment_gateways"
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                        >
                          <div class="grid grid-cols-3 gap-6">
                            <template v-if="selectedAccount">
                              <template
                                v-if="
                                  [
                                    'GBP',
                                    'USD',
                                    'EUR',
                                    'DKK',
                                    'NOK',
                                    'SEK',
                                  ].includes(selectedAccount.currency)
                                "
                              >
                                <!-- ova dva payment gateweya se izbacuju ako je valuta naloga neka od gore navedenih -->
                                <div
                                  v-for="(
                                    gateway, index
                                  ) in get_payments_gateway.payment_gateways.filter(
                                    (item) =>
                                      item.name !== 'securetrading' &&
                                      item.name !== 'polipay'
                                  )"
                                  :key="index"
                                  :class="
                                    selectedGateway.name === gateway.name
                                      ? 'border-blue'
                                      : ''
                                  "
                                  class="flex flex-col border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                                  @click="setGateway(gateway)"
                                >
                                  <img
                                    :src="
                                      require(`../../../assets/gateways/${
                                        gateway.name
                                      }${
                                        gateway.name === 'praxispay' ||
                                        gateway.name === 'bridgerpay' ||
                                        gateway.name === 'vaultspay'
                                          ? '.png'
                                          : '.svg'
                                      }`)
                                    "
                                    alt=""
                                    class="m-auto"
                                    style="
                                      height: 100%;
                                      width: auto;
                                      max-height: 48px;
                                    "
                                  />
                                  <div
                                    v-if="gateway.name === 'isignthis'"
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span> AUD deposits only </span>
                                  </div>
                                  <div
                                    v-else-if="
                                      whitelabel === 'TD365' &&
                                      gateway.name === 'trustpay'
                                    "
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span> Trustpay </span>
                                  </div>
                                  <div
                                    v-else-if="
                                      whitelabel === 'TDSouthAfrica' &&
                                      gateway.name === 'trustpay'
                                    "
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span> Payen </span>
                                  </div>
                                  <div
                                    v-else-if="gatewayLabels[gateway.name]"
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span>
                                      {{ gatewayLabels[gateway.name] }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <div
                                  v-for="(
                                    gateway, index
                                  ) in get_payments_gateway.payment_gateways"
                                  :key="index"
                                  :class="
                                    selectedGateway.name === gateway.name
                                      ? 'border-blue'
                                      : ''
                                  "
                                  class="flex flex-col border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                                  @click="setGateway(gateway)"
                                >
                                  <img
                                    :src="
                                      require(`../../../assets/gateways/${
                                        gateway.name
                                      }${
                                        gateway.name === 'praxispay' ||
                                        gateway.name === 'bridgerpay' ||
                                        gateway.name === 'vaultspay'
                                          ? '.png'
                                          : '.svg'
                                      }`)
                                    "
                                    alt=""
                                    class="m-auto"
                                    style="
                                      height: 100%;
                                      width: auto;
                                      max-height: 48px;
                                    "
                                  />
                                  <div
                                    v-if="gateway.name === 'isignthis'"
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span> AUD deposits only </span>
                                  </div>
                                  <div
                                    v-else-if="
                                      whitelabel === 'TD365' &&
                                      gateway.name === 'trustpay'
                                    "
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span> Trustpay </span>
                                  </div>
                                  <div
                                    v-else-if="
                                      whitelabel === 'TDSouthAfrica' &&
                                      gateway.name === 'trustpay'
                                    "
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span> Payen </span>
                                  </div>
                                  <div
                                    v-else-if="gatewayLabels[gateway.name]"
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span>
                                      {{ gatewayLabels[gateway.name] }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </dd>
                      </div>
                    </div>
                  </div>

                  <div v-if="whitelabel === 'Blackstone'">
                    <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                      <dd
                        v-if="get_payments_gateway.payment_gateways"
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                      >
                        <div class="grid grid-cols-3 gap-6">
                          <div
                            v-for="(
                              gateway, index
                            ) in get_payments_gateway.payment_gateways.filter(
                              (item) => item.name === 'bank'
                            )"
                            :key="index"
                            :class="
                              selectedGateway.name === gateway.name
                                ? 'border-blue'
                                : ''
                            "
                            class="flex flex-col border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                            @click="setGateway(gateway)"
                          >
                            <img
                              :src="
                                require(`../../../assets/gateways/${gateway.name}.svg`)
                              "
                              alt=""
                              class="m-auto"
                              style="
                                height: 100%;
                                width: auto;
                                max-height: 48px;
                              "
                            />
                            <div
                              v-if="gatewayLabels[gateway.name]"
                              class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                            >
                              <span class="mr-2">
                                {{ $t("via") }}
                              </span>
                              <span>
                                {{ gatewayLabels[gateway.name] }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </dd>
                    </div>
                    <div class="text-sm mb-4 leading-5 font-normal">
                      <span class="bank-instructions" v-html="bankText"></span>
                      <!-- <p class="mb-4">BlackStone Payment instructions</p>

                      <p>Bank: ABSA</p>
                      <p>Account Name: BlackStone Futures (Pty) Ltd</p>
                      <p>Sort Code: 63-20-05</p>
                      <p class="mb-4">Account Number: 4094965525</p>

                      <p>Bank: Barclays Bank Plc</p>
                      <p>Account name: Trade Nation Financial (Pty) Ltd</p>
                      <p>Sort Code: 20-00-00</p>
                      <p>Account Number: 43775888</p>
                      <p>IBAN: GB59BARC20000043775888</p>
                      <p>Currency: USD</p>
                      <p class="mb-4">Swift: BARCGB22</p>

                      <p>Bank: Barclays Bank PLC</p>
                      <p>Account name: Trade Nation Financial (Pty) Ltd Client Account</p>
                      <p>Sort Code: 20-00-00</p>
                      <p>Account Number: 83987590</p>
                      <p>IBAN: GB61BARC20000083987590</p>
                      <p>Currency: GBP</p>
                      <p class="mb-4">Swift Code: BARCGB22</p>

                      <p>Bank: Barclays Bank PLC</p>
                      <p>Account name: Trade Nation Financial (Pty) Ltd Client Account</p>
                      <p>Sort code: 20-00-00</p>
                      <p>Account Number: 78866755</p>
                      <p>IBAN: GB67BARC20000078866755</p>
                      <p>Currency: EUR</p>
                      <p class="mb-4">Swift Code: BARCGB22</p>

                      <p>Important notes:</p>
                      <p>Please state your account number for reference.</p> -->
                    </div>
                  </div>

               <!-- commented on 29/01/2025 - Not relevant to ICM  <div   
                    v-if="
                      whitelabel === 'OneTradingMarkets' ||
                      whitelabel === 'EagleGlobalMarkets' ||
                      whitelabel === 'TradeCoreUK'
                    "
                  >
                    <div>
                      <div class="mt-8 sm:mt-0 sm:border-gray-200 sm:py-5">
                        <dd
                          v-if="get_payments_gateway.payment_gateways"
                          class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0"
                        >
                          <div class="grid grid-cols-3 gap-6">
                            <template v-if="selectedAccount">
                              <template>
                                <div
                                  v-for="(
                                    gateway, index
                                  ) in get_payments_gateway.payment_gateways"
                                  :key="index"
                                  :class="
                                    selectedGateway.name === gateway.name
                                      ? 'border-blue'
                                      : ''
                                  "
                                  class="flex flex-col border-gray-200 border cursor-pointer rounded-md max-w-xs-gateway sm:col-span-1"
                                  @click="setGateway(gateway)"
                                >
                                   <img :src="require(`../../../assets/gateways/${gateway.name}${((gateway.name === 'praxispay' || gateway.name === 'vaultspay')
                                    && whitelabel === 'OneTradingMarkets') ? '-otm.png' : '.svg'}`)" class="m-auto rounded-md" :class="(gatewayLabels[gateway.name]
                                     || gateway.name === 'praxispay' || gateway.name === 'bridgerpay' || gateway.name === 'vaultspay') ? 'h-16':'h-24'" alt=""> 
                                  <img
                                    :src="checkAssetEGM(gateway.name)"
                                    alt=""
                                    class="m-auto"
                                    style="
                                      height: 100%;
                                      width: auto;
                                      max-height: 48px;
                                    "
                                  />
                                  <div
                                    v-if="gateway.name === 'isignthis'"
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span> AUD deposits only </span>
                                  </div>
                                  <div
                                    v-else-if="gatewayLabels[gateway.name]"
                                    class="text-xs text-gray-400 p-1 bottom-0 font-light border-t flex"
                                  >
                                    <span class="mr-2">
                                      {{ $t("via") }}
                                    </span>
                                    <span>
                                      {{ gatewayLabels[gateway.name] }}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </dd>
                      </div>
                    </div>
                  </div> -->

                  <div>
                    <div
                      v-if="selectedGateway.name === 'cupgeneric'"
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-2 sm:border-gray-200 sm:pt-5"
                    >
                      <dt class="text-sm leading-5 font-normal">
                        {{ $t("name-in-chinese") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-1"
                      >
                        <div class="sm:col-span-1">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              required: true,
                              regex: /[\u3400-\u9FBF]/,
                            }"
                            name="Name must be written in Chinese characters"
                          >
                            <div class="mt-1 relative rounded-md shadow-sm">
                              <input
                                id="name"
                                v-model="name"
                                aria-describedby="price-currency"
                                class="form-input h-12 font-light block w-full px-3 sm:text-sm sm:leading-5"
                                type="text"
                              />
                            </div>
                            <span class="text-sm text-red-600 h-4">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </dd>
                    </div>
                    <div
                      v-if="selectedGateway.name === 'icmcrypto'"
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-2 sm:border-gray-200 sm:pt-5"
                    >
                      <dt class="text-sm leading-5 font-normal">
                        {{ $t("Name") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-1"
                      >
                        <div class="sm:col-span-1">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{ required: true, alpha_spaces: true }"
                          >
                            <div class="mt-1 relative rounded-md shadow-sm">
                              <input
                                id="name"
                                v-model="name"
                                class="form-input h-12 font-light block w-full px-3 sm:text-sm sm:leading-5"
                                type="text"
                              />
                            </div>
                            <span class="text-sm text-red-600 h-4">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </dd>
                    </div>
                    <div
                      v-if="
                        selectedGateway.name === 'bank' ||
                        selectedPayment === 'Manual'
                      "
                    >
                      <bank-details-forms
                        v-if="
                          get_bank_account_forms.actions &&
                          whitelabel !== 'OneTradingMarkets' &&
                          whitelabel !== 'EagleGlobalMarkets' &&
                          whitelabel !== 'Blackstone' &&
                          whitelabel !== 'TradeCoreUK'
                        "
                        :bank="true"
                        :display-names="displayNames"
                        :fields="
                          get_bank_account_forms.actions.POST.fields.filter(
                            (item) => item.key !== 'account_number'
                          )
                        "
                        :form="form"
                      >
                      </bank-details-forms>
                      <div v-if="whitelabel === 'TD365'" class="mt-4">
                        <span v-html="bankText"></span>
                      </div>
                      <div v-if="whitelabel === 'TDSouthAfrica'" class="mt-4">
                        <span v-html="bankText"></span>
                      </div>
                      <div
                        v-if="whitelabel === 'OneTradingMarkets'"
                        class="mt-4"
                      >
                        <span v-html="bankText"></span>
                      </div>

                      <div
                        v-if="
                          whitelabel === 'EagleGlobalMarkets' ||
                          whitelabel === 'TradeCoreUK'
                        "
                        class="mt-4"
                      >
                        <span
                          class="bank-instructions"
                          v-html="bankText"
                        ></span>
                        <div v-if="selectedAccount.backend.type === 'MT4'">
                          <br /><br />
                          <p><strong>Naira Bank payment details:</strong></p>
                          <br />
                          <p><strong>ZENITH BANK</strong></p>
                          <br />
                          <p>Account Currency: Naira</p>
                          <p>Account Name: Eagle GM Ltd</p>
                          <p>Account Number: 1014628994</p>
                          <p>Sort Code: 057150136</p>
                          <p>Branch Address: 51 Awolowo Road, Ikoyi</p>
                          <br /><br />
                          <p><strong>Guaranty Trust Bank</strong></p>
                          <br />
                          <p>Account Currency: Naira</p>
                          <p>Account Name: Eagle GM Ltd</p>
                          <p>Account Number 0221621100</p>
                          <p>Sort Code: 058152243</p>
                          <p>Branch Address: 22/24 Catholic Mission Street</p>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-if="whitelabel === 'TDSouthAfrica' && selectedGateway.name !== 'trustpay' && selectedGateway.name !== 'isignthis'">
                      <p class="text-sm mb-4 leading-5 font-light text-gray-500">
                        Please enter the amount you wish to deposit <strong>(AUD deposit only)</strong>
                      </p>
                    </div> -->
                    <div
                      v-if="
                        whitelabel === 'TDSouthAfrica' &&
                        selectedGateway.name === 'trustpay'
                      "
                    >
                      <p
                        class="text-sm mb-4 leading-5 font-light text-gray-500"
                      >
                        Please enter the amount you wish to deposit
                        <strong>(Non AUD deposits)</strong>
                      </p>
                    </div>
                  </div>
                  <div>
                    <div
                      v-if="
                        selectedGateway.amount_field ||
                        (whitelabel === 'OneTradingMarkets' &&
                          selectedGateway.name === 'praxispay') ||
                        (get_profile.state === 'Limited' &&
                          selectedGateway.name !== 'bank')
                      "
                      class="mt-8 sm:mt-0 sm:grid sm:grid-cols-2 sm:border-gray-200 sm:pt-5"
                    >
                      <dt class="text-sm leading-5 font-normal">
                        {{ $t("enter-amount") }}
                      </dt>
                      <dd
                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-1"
                      >
                        <div class="sm:col-span-1">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="amount"
                            rules="required"
                          >
                            <div
                              class="mt-1 relative rounded-md shadow-sm input"
                            >
                              <div
                                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                              >
                                <span
                                  v-if="selectedAccount"
                                  class="text-gray-300 sm:text-md sm:leading-5"
                                  v-html="
                                    new Intl.NumberFormat('en-US', {
                                      style: 'currency',
                                      currency: selectedAccount.currency,
                                    })
                                      .format()
                                      .slice(0, -3)
                                  "
                                >
                                </span>
                              </div>
                              <input
                                id="amount1"
                                v-model="amount"
                                :disabled="
                                  $store.getters.get_live_accounts.length === 0
                                "
                                aria-describedby="price-currency"
                                class="form-input h-12 font-light block w-full pl-7 pr-3 sm:text-sm sm:leading-5"
                                step="any"
                                type="number"
                              />
                            </div>
                            <span class="text-sm text-red-600 h-4">{{
                              errors[0]
                            }}</span>
                            <span
                              v-if="error.value"
                              class="text-sm text-red-600 h-4"
                              >{{ error.message }}</span
                            >
                          </ValidationProvider>
                        
                        </div>
                      </dd>
                    </div>
                  </div>
                  <div
                    v-if="
                      !(
                        whitelabel === 'TD365' &&
                        selectedGateway.name === 'bank'
                      ) &&
                      !(
                        whitelabel === 'TDSouthAfrica' &&
                        selectedGateway.name === 'bank'
                      ) &&
                      whitelabel !== 'Blackstone' &&
                      !(
                        whitelabel === 'OneTradingMarkets' &&
                        (selectedGateway.name === 'bank' ||
                          selectedGateway.name === undefined)
                      ) &&
                      !(
                        whitelabel === 'EagleGlobalMarkets' &&
                        (selectedGateway.name === 'bank' ||
                          selectedGateway.name === undefined)
                      ) &&
                      !(
                        whitelabel === 'TradeCoreUK' &&
                        (selectedGateway.name === 'bank' ||
                          selectedGateway.name === undefined)
                      )
                    "
                  >

                  <!-- BR#150 03/02/2026 - added cypto selection message - Mbeng -->
                  <div
                    v-if="(whitelabel === 'ICMMU' || whitelabel === 'ICMVC')
                          && selectedGateway
                          && selectedGateway.name === 'praxispay'"
                    class="alert alert-warning" style="color: #000000; font-size: 14px;"
                  >
                    <!-- <strong>{{$t("attention-for-crypto-only")}}</strong><br>
                    {{$t("instant-crypto-deposits-are-limited")}}<br>
                    {{$t("deposit-above-us-50000")}}  -->
                    <strong>Attention (For Crypto Payments Only):</strong><br>
                    <p style="color: #6B7280; font-size: 14px;">Instant Crypto deposits are limited to USD 50,000 per client per day.</p>
                    <p style="color: #6B7280; font-size: 14px;">Deposits above USD 50,000 are supported via a manual approval process.</p>
                    <p style="color: #6B7280; font-size: 14px;">All Manual Deposits will be processed only during office hours.</p>
                  </div>
                  <div
                    v-else-if="whitelabel === 'ICMTrader'
                              && selectedGateway
                              && ['icmcrypto', 'icmcrypto-trader'].includes(selectedGateway.name)"
                    class="alert alert-warning" style="color: #000000; font-size: 14px;"
                  >
                   <!-- <strong>{{$t("attention-for-crypto-only")}}</strong><br>
                     {{$t("instant-crypto-deposits-are-limited")}}<br>
                     {{$t("deposit-above-us-50000")}} -->
                     <strong>Attention:</strong><br>
                     <p style="color: #6B7280; font-size: 14px;">Instant Crypto deposits are limited to USD 50,000 per client per day.</p>
                     <p style="color: #6B7280; font-size: 14px;">Deposits above USD 50,000 are supported via a manual approval process.</p>
                     <p style="color: #6B7280; font-size: 14px;">All Manual Deposits will be processed only during office hours.</p>
                  </div>
                  
                  <!-- # #BR#130 Mbeng - terms and conditiona icmvc/icmmu 23/09/2025 -->
                  <br>
                  
                  <div class="mb-4 flex items-start" v-if="whitelabel==='ICMMU' || whitelabel==='ICMVC'">
                   <input
                    v-model="form.agree"
                    type="checkbox"
                    id="agree"
                    class="mt-1 mr-2"
                    required
                  />
                    <label for="agree" class="text-sm text-gray-700">
                    <!-- I agree to the  -->
                    {{$t("i-agree-to-the")}}
                    <a
                     :href="PdfUrl || null"
                     target="_blank"
                     rel="noopener noreferrer"
                     class="text-blue-600 hover:underline { 'pointer-events-none opacity-50': !PdfUrl }"
                  >
                    <!-- Terms and Conditions  -->
                    {{$t("terms-and-conditions")}}
                   </a>
                 </label>
                </div>

                    <div
                      v-if="$store.getters.get_live_accounts.length > 0"
                      class="mt-4 sm:grid sm:grid-cols-2"
                    >
                      <span class="sm:col-span-1"></span>
                      <span
                        class="inline-flex rounded-md shadow-sm w-full sm:col-span-1"
                      >
                        <Button
                          v-if="selectedGateway === 'paypal'"
                          :disabled="isDisabled"
                          class="relative block w-full bg-yellow-400 items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md focus:outline-none focus:shadow-outline-indigo"
                          type="submit"
                        >
                          <span class="flex justify-center">
                            {{ $t("pay-with") }}
                            <svg
                              class="ml-3"
                              fill="none"
                              height="20"
                              viewBox="0 0 75 20"
                              width="75"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M28.0445 4.93872H23.8942C23.7568 4.93863 23.6239 4.98762 23.5194 5.07685C23.4149 5.16609 23.3457 5.2897 23.3243 5.42542L21.6457 16.0679C21.638 16.1173 21.6411 16.1678 21.6548 16.2158C21.6684 16.2639 21.6923 16.3085 21.7249 16.3464C21.7574 16.3844 21.7978 16.4148 21.8432 16.4357C21.8886 16.4565 21.938 16.4673 21.988 16.4672H23.9694C24.1069 16.4673 24.2399 16.4182 24.3444 16.3289C24.4489 16.2395 24.518 16.1157 24.5393 15.9799L24.992 13.1095C25.0132 12.9737 25.0823 12.8501 25.1866 12.7607C25.291 12.6714 25.4238 12.6222 25.5612 12.6222H26.8751C29.609 12.6222 31.1868 11.2992 31.5988 8.67758C31.7845 7.53062 31.6067 6.62943 31.0697 5.9983C30.4798 5.30526 29.4336 4.93872 28.0445 4.93872ZM28.5233 8.82565C28.2963 10.3149 27.1585 10.3149 26.0582 10.3149H25.4319L25.8713 7.53365C25.8842 7.45228 25.9257 7.37818 25.9883 7.32466C26.0509 7.27115 26.1306 7.24175 26.213 7.24175H26.5C27.2495 7.24175 27.9565 7.24175 28.3218 7.66898C28.5397 7.92386 28.6064 8.30254 28.5233 8.82565ZM40.4505 8.77771H38.463C38.3806 8.77771 38.301 8.80711 38.2383 8.86062C38.1757 8.91414 38.1342 8.98824 38.1214 9.06961L38.0334 9.62549L37.8944 9.42402C37.4641 8.79956 36.5047 8.5908 35.5471 8.5908C33.3508 8.5908 31.475 10.2542 31.1097 12.5876C30.9198 13.7515 31.1898 14.8645 31.8501 15.6407C32.4557 16.3543 33.3223 16.6517 34.3534 16.6517C36.123 16.6517 37.1043 15.5138 37.1043 15.5138L37.0157 16.0661C37.0078 16.1155 37.0107 16.166 37.0242 16.2141C37.0377 16.2623 37.0615 16.3069 37.0939 16.345C37.1263 16.383 37.1666 16.4136 37.212 16.4346C37.2573 16.4556 37.3067 16.4665 37.3567 16.4666H39.147C39.2844 16.4667 39.4174 16.4176 39.5219 16.3283C39.6264 16.2389 39.6955 16.1151 39.7168 15.9793L40.7909 9.17702C40.7988 9.12776 40.796 9.07737 40.7825 9.02933C40.769 8.98128 40.7453 8.93674 40.7129 8.89877C40.6805 8.8608 40.6403 8.83032 40.595 8.80941C40.5497 8.78851 40.5004 8.7777 40.4505 8.77771ZM37.6802 12.6458C37.4884 13.7813 36.5872 14.5435 35.4378 14.5435C34.8607 14.5435 34.3995 14.3584 34.1034 14.0076C33.8096 13.6593 33.698 13.1635 33.7914 12.6112C33.9705 11.4855 34.8868 10.6984 36.0186 10.6984C36.583 10.6984 37.0418 10.8859 37.344 11.2397C37.6468 11.5972 37.767 12.096 37.6802 12.6458ZM51.0353 8.77771H49.0382C48.944 8.77786 48.8512 8.80099 48.768 8.84509C48.6848 8.88918 48.6136 8.95292 48.5606 9.03077L45.806 13.0882L44.6384 9.18916C44.6026 9.07024 44.5294 8.96602 44.4297 8.89192C44.3301 8.81781 44.2092 8.77777 44.085 8.77771H42.1224C42.0673 8.77756 42.013 8.79058 41.9639 8.81567C41.9149 8.84076 41.8725 8.8772 41.8404 8.92196C41.8083 8.96673 41.7873 9.01851 41.7793 9.07301C41.7712 9.12751 41.7763 9.18314 41.7941 9.23528L43.9939 15.691L41.9258 18.6106C41.889 18.6624 41.8672 18.7233 41.8628 18.7866C41.8583 18.85 41.8714 18.9133 41.9005 18.9697C41.9296 19.0261 41.9737 19.0734 42.028 19.1064C42.0822 19.1394 42.1445 19.1568 42.208 19.1568H44.2027C44.2958 19.1569 44.3876 19.1345 44.4702 19.0914C44.5527 19.0482 44.6236 18.9857 44.6767 18.9092L51.3193 9.32085C51.3553 9.26897 51.3765 9.20823 51.3804 9.14521C51.3843 9.08219 51.371 9.01929 51.3417 8.96333C51.3124 8.90738 51.2684 8.8605 51.2144 8.82778C51.1604 8.79505 51.0985 8.77774 51.0353 8.77771Z"
                                fill="#253B80"
                              />
                              <path
                                d="M57.6471 4.9386H53.4962C53.3589 4.93865 53.2261 4.98771 53.1218 5.07693C53.0174 5.16615 52.9484 5.28968 52.927 5.4253L51.2484 16.0678C51.2406 16.1171 51.2436 16.1675 51.2571 16.2155C51.2707 16.2636 51.2945 16.3081 51.3269 16.3461C51.3593 16.384 51.3996 16.4145 51.4449 16.4354C51.4902 16.4563 51.5395 16.4671 51.5894 16.4671H53.7195C53.8156 16.467 53.9085 16.4325 53.9815 16.37C54.0545 16.3075 54.1027 16.221 54.1176 16.126L54.594 13.1093C54.6153 12.9736 54.6843 12.8499 54.7887 12.7606C54.893 12.6713 55.0259 12.6221 55.1632 12.622H56.4765C59.211 12.622 60.7882 11.2991 61.2009 8.67745C61.3872 7.53049 61.2082 6.6293 60.6711 5.99817C60.0818 5.30514 59.0362 4.9386 57.6471 4.9386ZM58.1259 8.82553C57.8996 10.3148 56.7617 10.3148 55.6609 10.3148H55.0352L55.4752 7.53352C55.4878 7.45215 55.5291 7.37799 55.5917 7.32444C55.6542 7.2709 55.7339 7.24152 55.8162 7.24163H56.1033C56.8521 7.24163 57.5597 7.24163 57.9251 7.66885C58.1429 7.92373 58.2091 8.30242 58.1259 8.82553ZM70.0525 8.77759H68.0663C67.9839 8.77736 67.9042 8.80669 67.8416 8.86026C67.779 8.91382 67.7377 8.98806 67.7252 9.06948L67.6372 9.62537L67.4977 9.42389C67.0674 8.79943 66.1086 8.59067 65.1509 8.59067C62.9547 8.59067 61.0795 10.2541 60.7142 12.5874C60.5248 13.7514 60.7937 14.8644 61.4539 15.6406C62.0608 16.3542 62.9262 16.6516 63.9572 16.6516C65.7268 16.6516 66.7081 15.5137 66.7081 15.5137L66.6195 16.066C66.6116 16.1154 66.6145 16.166 66.6281 16.2143C66.6417 16.2625 66.6656 16.3072 66.6981 16.3453C66.7307 16.3834 66.7711 16.414 66.8166 16.4349C66.8622 16.4558 66.9117 16.4666 66.9618 16.4665H68.7514C68.8888 16.4664 69.0216 16.4173 69.126 16.3279C69.2304 16.2386 69.2994 16.1149 69.3207 15.9792L70.3954 9.1769C70.403 9.12748 70.3999 9.077 70.3861 9.02892C70.3724 8.98084 70.3484 8.9363 70.3158 8.89836C70.2833 8.86042 70.2429 8.82999 70.1974 8.80914C70.152 8.78829 70.1025 8.77753 70.0525 8.77759ZM67.2822 12.6457C67.0917 13.7811 66.1893 14.5434 65.0399 14.5434C64.464 14.5434 64.0015 14.3583 63.7054 14.0075C63.4117 13.6592 63.3012 13.1634 63.3935 12.6111C63.5737 11.4854 64.4888 10.6983 65.6206 10.6983C66.185 10.6983 66.6438 10.8858 66.946 11.2396C67.2501 11.5971 67.3702 12.0959 67.2822 12.6457ZM72.3956 5.23049L70.6922 16.0678C70.6843 16.1171 70.6873 16.1675 70.7009 16.2155C70.7144 16.2636 70.7382 16.3081 70.7706 16.3461C70.8031 16.384 70.8433 16.4145 70.8886 16.4354C70.934 16.4563 70.9833 16.4671 71.0332 16.4671H72.7458C73.0304 16.4671 73.2719 16.2608 73.3156 15.9798L74.9954 5.33791C75.0032 5.28858 75.0002 5.23815 74.9867 5.19008C74.9731 5.14201 74.9493 5.09744 74.9169 5.05944C74.8845 5.02144 74.8443 4.99091 74.7989 4.96994C74.7536 4.94898 74.7043 4.93808 74.6543 4.93799H72.7367C72.6543 4.93828 72.5748 4.96788 72.5123 5.02147C72.4498 5.07507 72.4084 5.14917 72.3956 5.23049Z"
                                fill="#179BD7"
                              />
                              <path
                                d="M4.41009 18.5353L4.72748 16.5193L4.02049 16.5029H0.644531L2.99065 1.627C2.99763 1.58154 3.02072 1.54011 3.0557 1.51026C3.09068 1.48041 3.13522 1.46412 3.1812 1.46436H8.87354C10.7633 1.46436 12.0674 1.8576 12.7483 2.63378C13.0675 2.99789 13.2708 3.37839 13.3692 3.79712C13.4723 4.23649 13.4741 4.76142 13.3734 5.40166L13.3661 5.44839V5.85863L13.6853 6.03947C13.929 6.16293 14.1481 6.32994 14.3316 6.53224C14.6047 6.84356 14.7813 7.23923 14.856 7.70833C14.933 8.19078 14.9075 8.76487 14.7813 9.41482C14.6357 10.1625 14.4002 10.8136 14.0822 11.3465C13.8016 11.8238 13.4244 12.2372 12.9747 12.5602C12.5523 12.86 12.0504 13.0875 11.483 13.2332C10.9332 13.3764 10.3063 13.4486 9.61876 13.4486H9.17576C8.85898 13.4486 8.5513 13.5627 8.30977 13.7672C8.06858 13.9739 7.90858 14.2595 7.85827 14.5731L7.82489 14.7546L7.26415 18.3077L7.23866 18.4382C7.23199 18.4795 7.22046 18.5001 7.20347 18.5141C7.187 18.5275 7.16647 18.535 7.14521 18.5353H4.41009Z"
                                fill="#253B80"
                              />
                              <path
                                d="M13.9873 5.49585C13.9703 5.60448 13.9509 5.71553 13.929 5.82962C13.1783 9.68378 10.6101 11.0152 7.33005 11.0152H5.65997C5.25884 11.0152 4.92081 11.3065 4.85831 11.7022L4.00324 17.1251L3.76111 18.6623C3.75146 18.7232 3.75514 18.7856 3.7719 18.845C3.78866 18.9044 3.81809 18.9595 3.85818 19.0064C3.89826 19.0534 3.94804 19.0911 4.0041 19.1169C4.06015 19.1428 4.12114 19.1562 4.18287 19.1562H7.14495C7.49572 19.1562 7.79369 18.9014 7.84891 18.5555L7.87804 18.405L8.43574 14.8658L8.47155 14.6716C8.52616 14.3244 8.82474 14.0696 9.1755 14.0696H9.61851C12.4883 14.0696 14.7349 12.9044 15.3916 9.53268C15.6659 8.12416 15.5239 6.94806 14.7981 6.12091C14.568 5.86504 14.2933 5.65323 13.9873 5.49585Z"
                                fill="#179BD7"
                              />
                              <path
                                d="M13.2021 5.1825C12.9624 5.11316 12.7186 5.05905 12.4721 5.02047C11.9849 4.94561 11.4926 4.90969 10.9998 4.91306H6.53818C6.36839 4.91293 6.20415 4.97355 6.07515 5.08396C5.94615 5.19436 5.86091 5.34728 5.83483 5.51506L4.88571 11.5266L4.8584 11.702C4.88797 11.5106 4.98505 11.3361 5.13209 11.2101C5.27913 11.0841 5.46642 11.0149 5.66006 11.015H7.33014C10.6102 11.015 13.1784 9.68297 13.9291 5.82942C13.9516 5.71533 13.9704 5.60427 13.9874 5.49564C13.7893 5.39177 13.5828 5.30468 13.3702 5.2353C13.3145 5.2168 13.2584 5.1992 13.2021 5.1825Z"
                                fill="#222D65"
                              />
                              <path
                                d="M5.83429 5.51523C5.86014 5.3474 5.94534 5.19441 6.0744 5.08405C6.20347 4.9737 6.36783 4.9133 6.53764 4.91383H10.9993C11.5278 4.91383 12.0212 4.94842 12.4715 5.02124C12.7762 5.06913 13.0767 5.14076 13.3703 5.23546C13.5918 5.30889 13.7975 5.39567 13.9874 5.49581C14.2108 4.07151 13.9856 3.10175 13.2155 2.22362C12.3665 1.2569 10.8342 0.843018 8.87344 0.843018H3.1811C2.78057 0.843018 2.43891 1.13431 2.37701 1.53059L0.0060138 16.5595C-0.00502992 16.6292 -0.00082816 16.7006 0.01833 16.7686C0.0374882 16.8366 0.0711482 16.8996 0.116995 16.9534C0.162841 17.0071 0.219786 17.0503 0.283911 17.0799C0.348037 17.1096 0.417823 17.125 0.488467 17.125H4.00279L4.88516 11.5268L5.83429 5.51523Z"
                                fill="#253B80"
                              />
                            </svg>
                          </span>
                        </Button>
                        <!-- #BR#130 Mbeng - terms and conditiona icmvc/icmmu 23/09/2025 -->
                        <Button
                         v-else-if="whitelabel==='ICMMU' || whitelabel==='ICMVC'"
                          :disabled="!form.agree || checkTradingDays"
                          class="relative block w-full bg-main-button-color items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
                          type="submit"
                          >
                          {{ $t("make-a-deposit") }}
                         </Button>
                        
                        <Button
                          v-else 
                          :disabled="isDisabled || checkTradingDays"
                          class="relative block w-full bg-main-button-color items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
                          type="submit"
                        >
                          {{ $t("make-a-deposit") }}
                        </Button>
                       
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    whitelabel !== 'ICMEU' &&
                    whitelabel !== 'TD365' &&
                    whitelabel !== 'TDSouthAfrica' &&
                    whitelabel !== 'Blackstone' &&
                    whitelabel !== 'OneTradingMarkets' &&
                    whitelabel !== 'EagleGlobalMarkets' &&
                    whitelabel !== 'GCCBrokers' &&
                    whitelabel !== 'TradeCoreUK' &&
                    whitelabel !== 'TradiNext'
                  "
                  class="rounded-md mt-20"
                >
                  <div class="flex">
                    <div class="flex-shrink-0"></div>
                    <div class="ml-3">
                      <h3
                        class="text-sm leading-5 font-normal"
                        v-if="whitelabel !== 'VCGMarkets'"
                      >
                        {{ $t("important-information") }}
                      </h3>
                      <div
                        v-if="whitelabel === 'ICMVC'"
                        class="mt-2 text-sm leading-5 text-gray-500"
                      >
                        <p style="white-space: pre-line">
                          {{
                            $t(
                              "we-are-unable-to-accept-third-party-payments-all-funds-must-be-transferred-from-an-account-owned-by-"
                            )
                          }}
                        </p>
                        <p class="mt-2" style="white-space: pre-line">
                          {{
                            $t(
                              "credit-card-debit-card-copies-may-be-required-to-verify-cards-for-deposits-and-withdrawals"
                            )
                          }}
                        </p>
                        <p class="mt-2" style="white-space: pre-line">
                          {{
                            $t(
                              "icm-capital-limited-saint-vincent-reserves-the-right-in-its-sole-discretion-to-correct-any-errors-or"
                            )
                          }}
                        </p>
                      </div>
                      <div
                        v-if="
                          whitelabel === 'ICMCapital' ||
                          whitelabel === 'ICMMENA' ||
                          whitelabel === 'ICMMU' ||
                          whitelabel === 'ICMSC' ||
                          whitelabel === 'ICMAP' ||
                          whitelabel === 'ICMTrader' ||
                          whitelabel === 'ICMEU'
                        "
                        class="mt-2 text-sm leading-5 text-gray-500"
                      >
                        <p style="white-space: pre-line">
                          <!--//BR#78 - Mbeng - 12/11/2025 - ICM capital, change to ICM Trader LLC-->
                          <span v-if="whitelabel === 'ICMTrader'">
                            {{
                              $t(
                                "We-are-unable-to-accept-third-party-payments"
                              ).replace("ICM Capital", "ICM Trader LLC") 
                            }}
                          </span>
                          <span v-else>
                            {{
                              $t("We-are-unable-to-accept-third-party-payments")
                            }}
                          </span>
                        </p>
                        <p class="mt-2" style="white-space: pre-line">
                          {{
                            $t(
                              "credit-card-debit-card-copies-may-be-required-to-verify-cards-for-deposits-and-withdrawals"
                            )
                          }}
                        </p>
                        <p
                          v-if="whitelabel === 'ICMTrader'"
                          class="mt-2"
                          style="white-space: pre-line"
                        >
                          {{
                            $t(
                              "deposits-may-take-up-to-1-business-day-to-process"
                            )
                          }}
                        </p>
                        <template v-if="selectedPayment">
                          <p
                            v-if="
                              (whitelabel === 'ICMCapital' ||
                                whitelabel === 'ICMMENA') &&
                              selectedPayment.name === 'PayPal'
                            "
                            class="mt-2"
                            style="white-space: pre-line"
                          >
                            {{ $t("for-PayPal-deposits") }}
                          </p>
                        </template>
                        <p class="mt-2" style="white-space: pre-line">
                          <!-- EER#67 mbeng 18/08/2025 -->
                          <span v-if="whitelabel === 'ICMTrader'">
                            {{
                              $t(
                                "ICM-Capital-Ltd-reserves-the-right-in-its-sole-discretion"
                              ).replace("ICM Capital Ltd", "ICM Trader LLC")
                            }}
                          </span>
                          <span v-else>
                            {{
                              $t(
                                "ICM-Capital-Ltd-reserves-the-right-in-its-sole-discretion"
                              )
                            }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              !(
                whitelabel === 'TDSouthAfrica' &&
                $store.getters.get_profile.state === 'Pending'
              )
            "
          >
            <div
              v-if="
                account_data.length === 0 &&
                (whitelabel === 'ICMEU'
                  ? $store.getters.get_profile.state !== 'Pending' &&
                    $store.getters.get_profile.state !== 'Review'
                  : account_data.length === 0)
              "
              class="mx-8"
            >
              <need-trading-account-alert
                :title="
                  $t('you-need-to-have-a-trading-account-in-order-to-deposit')
                "
              >
              </need-trading-account-alert>
            </div>
          </div>
        </form>
        <!--#BR#26 - Mbeng Atemson - 23/01/2025 - icmtrader crypto -->
      <div>
            <!-- Modal -->
          <DepositModal
            :isVisible="isModalOpen"
            :paymentRequest="paymentRequest"
            :amount="form.amount"
          />
      </div>
      </ValidationObserver>
      
    </div>
    <limited-state-upgrade-modal
      v-if="showLimitedStateUpgradeModalComputed"
      text="Your account is in Limited state and your Deposit limit has been exceeded."
      @close="closeModal"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/Header";
import BankDetailsForms from "@/views/payments/bank-details/BankDetailsForms";
import CompleteIdIdentification from "@/components/CompleteIdIdentification";
import gatewayLabels from "./gateways";
import NeedTradingAccountAlert from "@/components/NeedTradingAccountAlert";
import LimitedStateUpgradeModal from "@/views/LimitedStateUpgradeModal";
import AlertNav from "@/components/AlertNav.vue";
import DepositModal from "@/views/payments/deposit/DepositModal.vue"; 
import TaxDetailsAlert from "@/components/TaxDetailsAlert.vue"; // Mbeng 9/06/2025 For ICMMU Tax details

export default {
  name: "DepositFunds",
  components: {
    AlertNav,
    Header,
    BankDetailsForms,
    CompleteIdIdentification,
    NeedTradingAccountAlert,
    LimitedStateUpgradeModal,
    DepositModal,
    TaxDetailsAlert, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
  },
  data() {
    return {
      whitelabel: process.env.VUE_APP_WHITELABEL,
      selectedAccount: null,
      selectedPayment: null,
      selectedGateway: {},
      amount: "",
      name: "",
      showModal: false,
      isDisabled: false,
      form: {},
      inputNumberVisible: true,
      inputNumberError: "",
      dotValue: 0,
      response: {
        hasData: false,
      },
      displayNames: [
        "currency",
        "amount",
        "account_name",
        "bank_name",
        "amount_in_words",
      ],
      gatewayLabels: gatewayLabels,
      error: {
        value: false,
        message: "",
      },
      languageDirection: "",
      bankText: "",
      showLimitedStateUpgradeModal: false,
      showLimitedUserMessage: false,

      showTaxAlert: false,
      profileLoaded: false,
      agree: false, //BR#130 - mbeng - terms and conditions - 23/09/2025

      //#BR#26
      isModalOpen: false, // Modal visibility
      paymentRequest: {
        address: "TFF6DSpWtsmkBj2rk7c2cuaLnL72KRL5Vs", // Fixed address
        amount: 0, // To be dynamically set
        coin:  "USDTTRC20" , // Coin type
        qr_code_url: "/src/assets/icmtrader-usdt1.png/", // QR Code URL
      },
    };
  },
  computed: {
    ...mapGetters([
      "get_profile",
      "get_bank_account_forms",
      "get_payments_gateway",
      "get_uploaded_documents",
    ]),
    get_deposit_methods() {
      const t = this.$t.bind(this);
      const methods = this.$store.getters.get_deposit_methods.map((item) => {
        if (
          item.name === "Credit Card" &&
          (process.env.VUE_APP_WHITELABEL === "ICMCapital" ||
            process.env.VUE_APP_WHITELABEL === "ICMMENA" ||
            process.env.VUE_APP_WHITELABEL === "GCCBrokers" ||
            process.env.VUE_APP_WHITELABEL === "TradiNext")
        ) {
          item.name_i18n = t("credit-debit-card");
          item.name = t("credit-debit-card");
          return item;
        } else if (
          item.name === "PraxisPay" &&
          process.env.VUE_APP_WHITELABEL === "GCCBrokers"
        ) {
          item.name = "GCC Brokers Cashier";
          return item;
        }
        return item;
      });
      if (this.whitelabel === "VCGMarkets") {
        return methods.filter((item) => item?.gateways.length > 0);
      }
      return methods;
    },
    account_data() {
      if (this.whitelabel === "OrbitInvest") {
        return this.$store.getters.get_account_data.filter(
          (account) =>
            account.backend.mode === "Live" &&
            account.backend.name === "Investments"
        );
      } else {
        return this.$store.getters.get_account_data.filter(
          (account) => account.backend.mode === "Live"
        );
      }
    },
    // on select forms, we need to set dir = 'rtl' instead of default dir='auto'
    // so non translated text would show the corect way on arab and persian pages
    checkLanguageDirection() {
      this.languageDirection = this.$store.getters.get_lang;
      if (this.lang === "ar" || this.lang === "fa") {
        return document.getElementById("body").dir;
      } else {
        return document.getElementById("body").dir;
      }
    },
    showLimitedStateUpgradeModalComputed() {
      return (this.showLimitedStateUpgradeModal =
        this.$store.getters.get_limited_state_upgrade_modal);
    },
    checkTradingDays() {
      if (
        this.whitelabel === "VCGMarkets" &&
        this.$store.getters.get_trading_days === 0
      ) {
        return true;
      }
      return false;
    },

    // computedPaymentRequest() {
    //   return {
    //     total_amount: this.form.amount,
    //     //valid_until: this.calculateValidUntil(),
    //   };
    // },

    //#BR#130 Mbeng - terms and conditiona icmvc/icmmu 23/09/2025
    PdfUrl() {
      
      const lang = this.$store.getters.get_lang || 'en';

      const mapICMMU = {
        en: '/Payments-Terms-and-Conditions-MU.pdf',
        ar: '/Payments-Terms-and-Conditions-MU-AR.pdf',
        es: '/Payments-Terms-and-Conditions-MU.pdf',
        pt: '/Payments-Terms-and-Conditions-MU.pdf',
        th: '/Payments-Terms-and-Conditions-MU-TH.pdf',
        ms: '/Payments-Terms-and-Conditions-MU-MS.pdf',
        vi: '/Payments-Terms-and-Conditions-MU.pdf',
        id: '/Payments-Terms-and-Conditions-MU.pdf',
      };

      const mapICMVC = {
        en: '/Payments-Terms-and-Conditions-VC.pdf',
        ar: '/Payments-Terms-and-Conditions-VC-AR.pdf',
        es: '/Payments-Terms-and-Conditions-VC.pdf',
        pt: '/Payments-Terms-and-Conditions-VC.pdf',
        th: '/Payments-Terms-and-Conditions-VC-TH.pdf',
        ms: '/Payments-Terms-and-Conditions-VC-MS.pdf',
        vi: '/Payments-Terms-and-Conditions-VC.pdf',
        id: '/Payments-Terms-and-Conditions-VC.pdf',
      };

      const whitelabel = process.env.VUE_APP_WHITELABEL;

      if (whitelabel === 'ICMMU') {
        return mapICMMU[lang] || mapICMMU.en;
      } else if (whitelabel === 'ICMVC') {
        return mapICMVC[lang] || mapICMVC.en;
      }

      return mapICMMU.en; 
    }

  },

  created() {
    this.$store.dispatch("payments_gateway");
    this.$store.dispatch("account_data").then(() => {
      // on TD365 , TDSouthAcrica and Blackstone
      // when user clicks on deposit in account summary card
      // we set ID of sellected account in state.js selectedAccountId
      // here we check if selectedAccountId is set and if it is,
      // we find the account with that ID and set it as the active account
      // we then reset the value od selectedAccountId to null
      let selectedAccountID = this.$store.getters.get_selected_account_id;
      if (selectedAccountID !== "") {
        var localStorageAccount = this.account_data.filter(function (el) {
          return el.id == selectedAccountID;
        });
        this.selectedAccount = localStorageAccount[0];
        this.$store.dispatch("deposit_methods", this.selectedAccount.id);
        this.$store.commit("RESET_SELECTED_ACCOUT_ID");
      } else if (this.account_data.length > 0) {
        this.selectedAccount = this.account_data[0];
        this.$store.dispatch("deposit_methods", this.selectedAccount.id);
      }
      // we are preselecting payment gateway to the first one in the list
      if (this.whitelabel === "TD365" || this.whitelabel === "TDSouthAfrica") {
        this.setGateway(this.get_payments_gateway.payment_gateways[0]);
      }
    });
  },
  methods: {
     checkAsset(name) {
      if (name === "totalprocessing") {
        return require(`../../../assets/total_processing.png`);
      }
      if (this.whitelabel === "ICMTrader" && name === "icmcup") {
        name = "icmcup-icmtrader";
      } else if (this.whitelabel === "ICMTrader" && name === "icmcrypto") {
        name = "icmcrypto-trader";
      }
      // if(this.whitelabel === 'GCCBrokers' && name === 'praxispay') {
      //   name = 'praxispay-gccBrokers'
      // }
      if (this.whitelabel === "GCCBrokers" && name === "praxispay") {
        name = "gcc-brokers-cashier";
      }
      if (this.whitelabel === "VCGMarkets" && name === "praxispay") {
        try {
          return require(`../../../assets/gateways/praxis_VCG.png`);
        } catch (e) {
          return require(`../../../assets/logo-placeholder.png`);
        }
      }
      if (this.whitelabel === "VCGMarkets" && name === "bridgerpay") {
        try {
          return require(`../../../assets/VCGMarkets_new_black_logo.svg`);
        } catch (e) {
          return require(`../../../assets/logo-placeholder.png`);
        }
      }
      try {
        return require(`../../../assets/gateways/${name}${
          name === "praxispay" ||
          name === "bridgerpay" ||
          name === "vaultspay" ||
          name === "flutterwave" ||
          name === "paystack" ||
          name === "quickteller" ||
          name === "icmcrypto" ||
          name === "icmcrypto-trader" ||
          name === "praxispay-gccBrokers" ||
          name === "bitpace"
            ? ".png"
            : name === "gcc-brokers-cashier"
            ? ".webp"
            : ".svg"
        }`);
      } catch (e) {
        return require(`../../../assets/logo-placeholder.png`);
      }
    },
    checkAssetEGM(name) {
      try {
        if (this.whitelabel === "OneTradingMarkets") {
          if (name === "gatetopay") {
            return require(`../../../assets/gateways/gatetopay-otm.svg`);
          } else if (name === "b2binpay") {
            return require(`../../../assets/gateways/b2binpay-otm.svg`);
          } else if (name === "bitpace") {
            return require(`../../../assets/gateways/bitpace.png`);
          } else {
            return require(`../../../assets/gateways/${name}${
              name === "praxispay" || name === "vaultspay" ? "-otm.png" : ".svg"
            }`);
          }
        } else {
          return require(`../../../assets/gateways/${name}${
            name === "flutterwave" ||
            name === "paystack" ||
            name === "quickteller"
              ? ".png"
              : ".svg"
          }`);
        }
      } catch (e) {
        return require(`../../../assets/logo-placeholder.png`);
      }
    },
    updatePaymentMethods() {
      this.$store
        .dispatch("deposit_methods", this.selectedAccount.id)
        .then(() => {
          // this.selectedPayment = this.get_deposit_methods[0]
          this.selectedPayment = null;
          this.selectedGateway = {};
        });
    },
    updateSelectedGateway() {
      // we need to reset selected Gateway because WeChat does not have selectedGateway and it will remember the last gateway that was selected
      this.selectedGateway = {};
      this.selectedGateway = this.get_payments_gateway.payment_gateways.filter(
        (item) => this.selectedPayment.gateways.includes(item.name)
      )[0];
      if (this.selectedGateway.name === "bank") {
        this.$store.dispatch("request_bank_instructions").then(() => {
          if (
            (this.get_profile.address.addr_country === "China" ||
              this.get_profile.address.addr_country === "Taiwan" ||
              this.get_profile.address.addr_country === "Hong Kong" ||
              this.get_profile.address.addr_country === "Macao") &&
            (process.env.VUE_APP_WHITELABEL === "ICMVC" ||
              process.env.VUE_APP_WHITELABEL === "ICMSC" ||
              process.env.VUE_APP_WHITELABEL === "ICMMU" ||
              process.env.VUE_APP_WHITELABEL === "ICMCapital" ||
              process.env.VUE_APP_WHITELABEL === "ICMMENA" ||
              process.env.VUE_APP_WHITELABEL === "GCCBrokers" ||
              process.env.VUE_APP_WHITELABEL === "TradiNext" ||
              process.env.VUE_APP_WHITELABEL === "ICMAP")
          ) {
            this.get_bank_account_forms.actions.POST.fields[0].choices = [
              { display_name: "USD", value: "USD" },
            ];
          }
        });
      }
      if (this.selectedPayment === "Manual") {
        this.$store.dispatch("request_bank_instructions");
      }
    },
    setGateway(gateway) {
      this.selectedGateway = gateway;
      // we need to reset the amount because it remembers the last amount that was entered
      // and if the other transaction does not have amount field, there will an error
      // because the amount.lenght will be > 0
      this.amount = "";
      if (
        (this.whitelabel === "OneTradingMarkets" ||
          this.whitelabel === "Blackstone" ||
          this.whitelabel === "EagleGlobalMarkets" ||
          this.whitelabel === "TradeCoreUK" ||
          this.whitelabel === "TDSouthAfrica" ||
          this.whitelabel === "TD365") &&
        gateway.name === "bank"
      ) {
        this.bankInstructions();
      }
    },
    setAccount(account) {
      this.selectedAccount = account;
      // we are preselecting payment gateway to the first one in the list
      if (this.whitelabel === "TD365" || this.whitelabel === "TDSouthAfrica") {
        this.setGateway(this.get_payments_gateway.payment_gateways[0]);
      }
    },
    bankInstructions() {
      this.form = {
        override_gateway: this.selectedGateway.name,
        trading_account: this.selectedAccount.id,
      };
      this.$store
        .dispatch("make_deposit_no_amount", this.form)
        .then((resp) => {
          this.response.url = resp.data.url;
          if (this.response.url) {
            this.paymentInstructions(this.response.url);
          }
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$notify({
            group: "foo",
            text: `${Object.values(err.data)}`,
            type: "warn",
          });
        });
    },
    paymentInstructions(url) {
      this.$store
        .dispatch("bank_payment_instructions", url)
        .then((resp) => {
          this.bankText = this.$sanitize(resp.data);
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$notify({
            group: "foo",
            text: `${Object.values(err.data)}`,
            type: "warn",
          });
        });
    },
    checkBackendType(type) {
      // EGM wanted to rename DXTrade to Eagletrade
      // if(type === 'DXTrade'){
      //   return 'Eagletrade'
      // } else {
      //   return type
      // }
      return type;
    },
    makeDeposit() {
      this.error.value = false;
      this.isDisabled = true;

      // if (
      //   this.whitelabel === "VCGMarkets" &&
      //   this.get_profile.state === "Limited"
      // ) {
      //   this.$notify({
      //     group: "foo",
      //     text: `Please upload your documents in order to Deposit'`,
      //     type: "warn",
      //   });
      //   return (this.isDisabled = false);
      // }
      if (this.selectedGateway.name === "bank") {
        this.form.account_number = this.selectedAccount.external_id;
        this.form.amount_in_words = this.$filters.toWords(this.form.amount);
        if (this.selectedAccount.backend.id) {
          this.form.backend = this.selectedAccount.backend.id;
        }
        this.$store
          .dispatch("set_bank_instructions", this.form)
          .then((resp) => {
            this.isDisabled = false;
            this.$notify({
              group: "foo",
              text: `${resp.data.message}`,
            });
          })
          .catch((err) => {
            this.isDisabled = false;
            this.$notify({
              group: "foo",
              text: `${Object.values(err.response.data)[0]}`,
              type: "warn",
            });
          });
      } else {
        // console.log(this.selectedPayment)
        if (this.selectedPayment === null) {
          this.form = {
            override_gateway: this.selectedGateway.name,
            trading_account: this.selectedAccount.id,
          };
        } else if (this.selectedGateway === {}) {
          this.form = {
            method: this.selectedPayment.value,
            trading_account: this.selectedAccount.id,
          };
        } else {
          this.form = {
            method: this.selectedPayment.value,
            override_gateway: this.selectedGateway.name,
            trading_account: this.selectedAccount.id,
          };
        }
        if (this.selectedGateway.amount_field) {
          this.form.amount = this.amount;
        }
        if (
          this.selectedGateway.name === "cupgeneric" ||
          this.selectedGateway.name === "icmcrypto"
        ) {
          this.form.name = this.name;
        }
        if (
          this.whitelabel === "EagleGlobalMarkets" ||
          this.whitelabel === "TradeCoreUK"
        ) {
          if (this.amount.length > 0) {
            this.form.amount = this.amount;
          } else {
            delete this.form.amount;
          }
        }
        if (
          this.whitelabel === "OneTradingMarkets" &&
          this.selectedGateway.name === "praxispay"
        ) {
          this.form.amount = this.amount;
        }
        // if (this.amount.length > 0 ) {
        //   this.form.amount = this.amount
        //   }
        this.response = {
          hasData: false,
          url: null,
          opening_type: null,
        };
        // console.log(this.amount.length)
        if (
          (this.whitelabel === "EagleGlobalMarkets" &&
            !(this.amount.length > 0)) ||
          (this.whitelabel === "TradeCoreUK" && !(this.amount.length > 0))
        ) {
          let openingType = this.selectedGateway.opening_type;
          if (openingType === "newtab") {
            this.$store
              .dispatch("make_deposit_no_amount", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "newtab";
                this.response.url = resp.data.url;
                window.open(resp.data.url, "_blank");
              })
              .catch((err) => {
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          } else {
            this.showModal = true;
            let windowReference = window.open();
            this.$store
              .dispatch("make_deposit_no_amount", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "modal";
                this.response.url = resp.data.url;
                // this.showModal = true
                // if (resp.data.opening_type === "newtab") {
                //   windowReference.location = resp.data.url
                //   // window.open(resp.data.url, "_blank")
                // } else {
                //   windowReference.close()
                // }
                windowReference.close();
              })
              .catch((err) => {
                windowReference.close();
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          }
        } else if (
          this.whitelabel !== "EagleGlobalMarkets" &&
          !(this.amount.length > 0) &&
          this.whitelabel !== "TradeCoreUK" &&
          !(this.amount.length > 0)
        ) {
          let openingType = this.selectedGateway.opening_type;
          if (openingType === "newtab") {
            this.$store
              .dispatch("make_deposit", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "newtab";
                this.response.url = resp.data.url;
                window.open(resp.data.url, "_blank");
                if (this.selectedGateway.name === "gatetopay") {
                  this.$store.dispatch("account_data").catch((error) => {
                    console.error("Error dispatching 'account_data': ", error);
                  });
                  this.$notify({
                    group: "foo",
                    text: `${this.$t("your-deposit-request-was-successful")}`,
                  });
                }
              })
              .catch((err) => {
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if ("state" in this.get_profile) {
                  if (
                    this.get_profile.state === "Limited" &&
                    err.status === 422
                  ) {
                    this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                    this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                    this.isDisabled = false;
                    return;
                  }
                }
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          } else {
            this.showModal = true;
            // let windowReference = window.open();
            this.$store
              .dispatch("make_deposit", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "modal";
                this.response.url = resp.data.url;
                // this.showModal = true
                // if (resp.data.opening_type === "newtab") {
                //   windowReference.location = resp.data.url
                //   // window.open(resp.data.url, "_blank")
                // } else {
                //   windowReference.close()
                // }
                // windowReference.close()
                if (this.selectedGateway.name === "gatetopay") {
                  this.$store.dispatch("account_data").catch((error) => {
                    console.error("Error dispatching 'account_data': ", error);
                  });
                  this.$notify({
                    group: "foo",
                    text: `${this.$t("your-deposit-request-was-successful")}`,
                  });
                }
              })
              .catch((err) => {
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if ("state" in this.get_profile) {
                  if (
                    this.get_profile.state === "Limited" &&
                    err.status === 422
                  ) {
                    this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                    this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                    this.isDisabled = false;
                    return;
                  }
                }
                // windowReference.close()
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          }
        }  else if (this.selectedPayment === null ) {
          let openingType = this.selectedGateway.opening_type;
          if (openingType === "newtab") {
            this.$store
              .dispatch("make_deposit_no_payment_method", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "newtab";
                this.response.url = resp.data.url;
                window.open(resp.data.url, "_blank");
              })
              .catch((err) => {
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if ("state" in this.get_profile) {
                  if (
                    this.get_profile.state === "Limited" &&
                    err.status === 422
                  ) {
                    this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                    this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                    this.isDisabled = false;
                    return;
                  }
                }
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          } else {
            this.showModal = true;
            // let windowReference = window.open();
            this.$store
              .dispatch("make_deposit_no_payment_method", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "modal";
                this.response.url = resp.data.url;
                // this.showModal = true
                // if (resp.data.opening_type === "newtab") {
                //   windowReference.location = resp.data.url
                //   // window.open(resp.data.url, "_blank")
                // } else {
                //   windowReference.close()
                // }
                // windowReference.close()
              })
              .catch((err) => {
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if ("state" in this.get_profile) {
                  if (
                    this.get_profile.state === "Limited" &&
                    err.status === 422
                  ) {
                    this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                    this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                    this.isDisabled = false;
                    return;
                  }
                }
                // windowReference.close()
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          }
         //BR#90 Mbeng 12/11/2025 the below block is for the redirection to the static crypto page
        // } else if (this.selectedGateway.name === "icmcrypto" && (this.get_profile.email !=="azin@icm.com" && this.get_profile.email !=="krisdev0415+102@gmail.com" && this.get_profile.email !=="roozbeh.valiollah@gmail.com")) {
        } else if (this.selectedGateway.name === "icmcrypto_static" ) { //BR#90 Mbeng 12/11/2025 ICMTrader: PSP Integration CoiniGo, for ICM Crypto (commented the above line as it was going to static page for particular emails)
          // #BR#26 - Mbeng Atemson - 23/01/2025 - icmtrader crypto deposit details popup 

          if (this.amount && String(this.amount).length > 0) {
            // Ensure form amount is set correctly
            this.form.amount = this.amount; 

            this.$store
              .dispatch("make_deposit", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "newtab";

                // Open DepositModal instead of redirecting
                this.paymentRequest.amount = this.form.amount; 
                const amount = this.form.amount; // Retrieve the amount
                const url = `/deposit-usdt?amount=${encodeURIComponent(amount)}`; // Add as a query parameter
                window.open(url,"_blank");
                //window.open("/deposit-usdt");
                //this.isModalOpen = true; // Open the modal
              })
              .catch((err) => {
                if (err.data?.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if (this.get_profile?.state === "Limited" && err.status === 422) {
                  this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                  this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                  this.isDisabled = false;
                  return;
                }

                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          } 
        } else {
          let openingType = this.selectedGateway.opening_type;
          if ((openingType === "newtab" && this.selectedGateway.name !== "icmcrypto") || (this.selectedGateway.name === "icmcrypto") //BR#90 Mbeng 12/11/2025 ICMTrader: PSP Integration CoiniGo, for ICM Crypto (commented the below lines as it was going to static page)
          // if ((openingType === "newtab" && this.selectedGateway.name !== "icmcrypto") || 
          // (this.selectedGateway.name === "icmcrypto" && 
          // (this.get_profile.email === "azin@icm.com" || 
          // this.get_profile.email !=="roozbeh.valiollah@gmail.com" ||
          //  this.get_profile.email === "krisdev0415+102@gmail.com"))  
          ) {
            this.$store
              .dispatch("make_deposit", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "newtab";
                this.response.url = resp.data.url;
                window.open(resp.data.url, "_blank");
                if (this.selectedGateway.name === "gatetopay") {
                  this.$store.dispatch("account_data").catch((error) => {
                    console.error("Error dispatching 'account_data': ", error);
                  });
                  this.$notify({
                    group: "foo",
                    text: `${this.$t("your-deposit-request-was-successful")}`,
                  });
                }
              })
              .catch((err) => {
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if ("state" in this.get_profile) {
                  if (
                    this.get_profile.state === "Limited" &&
                    err.status === 422
                  ) {
                    this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                    this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                    this.isDisabled = false;
                    return;
                  }
                }

                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          } else {
            this.showModal = true;
            let windowReference = window.open();
            this.$store
              .dispatch("make_deposit", this.form)
              .then((resp) => {
                this.isDisabled = false;
                this.response.hasData = true;
                this.response.opening_type = "modal";
                this.response.url = resp.data.url;
                // this.showModal = true
                // if (resp.data.opening_type === "newtab") {
                //   windowReference.location = resp.data.url
                //   // window.open(resp.data.url, "_blank")
                // } else {
                //   windowReference.close()
                // }
                windowReference.close();
                if (this.selectedGateway.name === "gatetopay") {
                  this.$store.dispatch("account_data").catch((error) => {
                    console.error("Error dispatching 'account_data': ", error);
                  });
                  this.$notify({
                    group: "foo",
                    text: `${this.$t("your-deposit-request-was-successful")}`,
                  });
                }
              })
              .catch((err) => {
                windowReference.close();
                if (err.data.error === "You cannot deposit less than 200.") {
                  this.error.value = true;
                  this.error.message = err.data.error;
                }
                if ("state" in this.get_profile) {
                  if (
                    this.get_profile.state === "Limited" &&
                    err.status === 422
                  ) {
                    this.$store.commit("SET_LIMITED_USER_MESSAGE", true);
                    this.$store.commit("SET_LIMITED_STATE_UPGRADE_MODAL", true);
                    this.isDisabled = false;
                    return;
                  }
                }
                this.isDisabled = false;
                this.$notify({
                  group: "foo",
                  text: `${Object.values(err.data)}`,
                  type: "warn",
                });
              });
          }
        }
      }
    },
    closeModal() {
      this.showLimitedStateUpgradeModal = false;
      this.showLimitedUserMessage = false;
    },
  // BR#98 
    checkTaxAlert(profile) {
      const nicFields = profile?.nic_fields || [];
      const requiredPriorities = [3, 4, 5, 6];
      const hasMissingTIN = requiredPriorities.some((priority) => {
        const field = nicFields.find((n) => n.priority === priority);
        return !field || !field.value;
      });
      this.showTaxAlert = hasMissingTIN;
      this.profileLoaded = true;
    }
  },

  watch: {
  get_profile: {
    handler(profile) {
      if (profile && profile.nic_fields) {
        this.checkTaxAlert(profile);
      }
    },
    immediate: true,
    deep: true,
  }
}
};
</script>
